export default {
	URL: 'https://api-copyjui.infinitum-ti.com/',
	API_URL: 'https://api-copyjui.infinitum-ti.com/api',
	OAPI_URL: 'https://api-copyjui.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2388',
	// API_URL: 'http://localhost:2388/api',
	// OAPI_URL: 'http://localhost:2388/oapi',
}
